module.exports = __webpack_public_path__ + "img/notive-default.bbdedb43.svg";